import { render, staticRenderFns } from "./PaymentTypeSelector.vue?vue&type=template&id=ca0b3194&scoped=true&"
import script from "./PaymentTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypeSelector.vue?vue&type=style&index=0&id=ca0b3194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0b3194",
  null
  
)

export default component.exports